module.exports = __webpack_public_path__ + "img/47422ad8d39e3fa9879b96a740763e7f.png";